import React from "react";
import styled from "styled-components";
import useScrollReveal from "../hooks/useScrollReveal";

const RevealWrapper = styled.div`
  opacity: 0;
  transform: translateY(32px);
  transition: opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1),
              transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ScrollReveal = ({ children, threshold, rootMargin }) => {
  const { ref, isVisible } = useScrollReveal({ threshold, rootMargin });

  return (
    <RevealWrapper ref={ref} className={isVisible ? "visible" : ""}>
      {children}
    </RevealWrapper>
  );
};

export default ScrollReveal;
